// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__L3Rf+","ldio":"spinner_ldio__bJQBe","spinnerEclipse":"spinner_spinnerEclipse__7jD1U"};